import React, { useEffect, useCallback } from "react";
import ReactDOM from "react-dom";
import { FaCheckCircle, FaTimesCircle, FaTimes } from "react-icons/fa";
import "./Alerts.css";

const icons = {
  success: <FaCheckCircle size={18} />,
  error:   <FaTimesCircle size={18} />,
};

const Toast = ({ alert, onDismiss }) => {
  const color = alert.color || "error";
  return (
    <div className={`toast-alert toast-alert--${color}`} role="alert">
      <span className="toast-alert__icon">{icons[color] || icons.error}</span>
      <span className="toast-alert__message">{alert.message}</span>
      <button className="toast-alert__close" onClick={() => onDismiss(alert)} aria-label="Close">
        <FaTimes size={13} />
      </button>
    </div>
  );
};

const Alerts = ({ alerts, setAlerts }) => {
  const onDismissAlert = useCallback(
    (a) => {
      setAlerts((prev) => prev.filter((item) => item.id !== a.id));
    },
    [setAlerts]
  );

  useEffect(() => {
    const timers = alerts.map((alert) => {
      const ms = alert.timeout ?? (alert.color === "success" ? 5000 : null);
      if (ms) {
        return setTimeout(() => onDismissAlert(alert), ms);
      }
      return null;
    });
    return () => timers.forEach((t) => clearTimeout(t));
  }, [alerts, onDismissAlert]);

  if (!alerts?.length) return null;

  return ReactDOM.createPortal(
    <div className="toast-alert__container">
      {alerts.map((alert) => (
        <Toast key={alert.id} alert={alert} onDismiss={onDismissAlert} />
      ))}
    </div>,
    document.body
  );
};

export default Alerts;